import { BrowserRouter, Route, Routes } from "react-router-dom";
import { JoinPage } from "./pages/join/join";
import { GamePage } from "./pages/game/game";
import { GuidePage } from "./pages/game/guide";
import { LoginPage } from "./pages/login/login";
import { ReportPage } from "./pages/report/report";
import { AlertComponent } from "./components/Alert/Alert";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/join" element={<JoinPage />} />
        <Route path="/guide" element={<GuidePage />} />
        <Route path="/game" element={<GamePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/report" element={<ReportPage />} />
      </Routes>
      <AlertComponent />
    </BrowserRouter>
  );
}

export default App;
